import { AfterContentInit, Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModel } from '../../../../core/models/select.mode';
import { ValidationHelper } from '../../helpers/validation.helper';

@Component({
  selector: 'select-input',
  templateUrl: './select-input.component.html',
  styleUrl: './select-input.component.scss',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectInputComponent),
      multi: true,
    },
  ],
})
export class SelectInputComponent implements  AfterContentInit {

  @Input() controller: AbstractControl;
  @Input() label: string;
  @Input() required: boolean;
  @Input() pattern: string;
  @Input() customError: string;
  @Input() isEnum: boolean;
  @Input() isRtl: boolean;
  @Input() options: SelectModel[] = [];
  @Input() multiple: boolean = false;
  @Input() backgroundColor: string;
  @Input() disabled: boolean;


  ngAfterContentInit(): void {
    this.disabled ? this.formControl.disable() : this.formControl.enable();
  }

  get formControl(): FormControl {
    return this.controller as FormControl;
  }

  get controllerName(): string {
    return Object.keys(this.controller.parent.controls).find(
      (key) => this.controller.parent.get(key) === this.controller
    ) || '';
  }

  checkControllerErrors() {
    return ValidationHelper.checkControllerErrors(this.controller);
  }

  isOptionSelected(key: any): boolean {
    if (!this.multiple) {
      return this.formControl.value === key;
    }
    const value = this.formControl.value;
    return value && Array.isArray(value) && value.includes(key);
  }

  toggleOption(value: any): void {
    if (!this.multiple) return;
    let currentValues = this.formControl.value || [];
    if (!Array.isArray(currentValues)) {
      currentValues = [];
    }

    if (currentValues.includes(value)) {
      currentValues = currentValues.filter(v => v !== value);
    } else {
      currentValues = [...currentValues, value];
    }
    this.formControl.setValue(currentValues);
  }
}
